import * as ActionTypes from '../actions'



const isGlobalsFetching = (state = false, action) => {
	switch (action.type) {
		case ActionTypes.LOAD_GLOBALS_REQUEST:
			return true;
		case ActionTypes.LOAD_GLOBALS_SUCCESS:
		case ActionTypes.LOAD_GLOBALS_FAILURE:
			return false;
		default:
			return state;
	}
}

export default isGlobalsFetching


// WEBPACK FOOTER //
// ./src/reducers/isGlobalsFetching.js